<template>
  <div class="detail-info-comment">
    <j-editor v-bind:value="value" upload-source="ipsys" :limit="5000" :height="200" ></j-editor>
    <div class="detail-info-comment-btns">
      <a-button type="primary" icon="check" @click="confirmClick"> {{ confirmText }} </a-button>
      <a-button icon="close" @click="$emit('cancel')">{{ cancelText }}</a-button>
    </div>
  </div>
</template>

<script>
import JEditor from './Editor'

export default {
  components: { JEditor },
  name: 'Comment',
  model: {
    prop: 'value',
    event: 'click',
  },
  props: {
    value: {
      type: String,
    },
    confirmText: {
      type: String,
      default: '确定',
    },
    cancelText: {
      type: String,
      default: '取消',
    },
  },

  methods: {
    confirmClick() {
      console.log('this.value = ', this.value) 
      this.$emit('confirm', this.value)
    },
  },
}
</script>


<style lang="less" scoped>
.detail-info-comment {
  display: flex;
  align-items: flex-end;
  justify-content: center;
  flex-direction: column;
  width: 100%;

  .tinymce-editor {
    width: 100%;
  }

  &-btns {
    font-size: 20px;

    button {
      margin-right: 16px;

      &:last-child {
        margin-right: 0;
      }
    }
  }
}
</style>